<template>
  <v-card class="elevation-0">
    <v-card-text>
      <v-container grid-list-xl class="pa-2">
        <v-layout row wrap>
          <v-flex xs6 v-for="instance in instances" :key="instance.id">
            <Item :id="instance.id"></Item>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import InstanceModel from '@/models/instance.js'
import Item from './teranex/Item'

export default {
  components: {
    Item
  },
  computed: {
    instances () {
      return _.filter(InstanceModel.instances_by_type("external_device"), (instance) => {
        return _.get(instance, "meta.type") == "blackmagic" && _.get(instance, "meta.device_config.type") == "teranex";
      });
    },
  }
}
</script>
